import React from 'react';

import {GenericNewElementPage} from 'app/components/general/GenericNewElementPage';
import {createNewProcedure} from 'app/procedures/actions';
import {useAsyncActions} from 'app/utils/redux';

export const NewProcedurePage = () => {
  const actions = useAsyncActions({
    createNewProcedure,
  });
  return (
    <GenericNewElementPage
      elementName={'procedure'}
      createNewDocument={(procedureData) =>
        actions.createNewProcedure(procedureData)
      }
    />
  );
};
